export enum DisplayOrder {
    MOBILE = 3,
    SIM = 4,
    AIRBOX = 5,
    FLYBOX = 6,
    MULTISIMI = 7,
    MULTISIMIA = 8,
    SMARTWATCH = 9,
    LIVEBOX = 10,
    VOIP = 11,
    LANDLINE = 12,
    TV = 13,
    CYBERSECURITY = 14,
}
